import { ApiResponse } from '@/domain'
import { backendApi } from '../backendApi'
import { AssuredPerson } from '@/domain/assured/Assured'

export const assuredPeopleApi = {
  getAssuredPeopleByContract: (contractId: string) =>
    backendApi.get<ApiResponse<AssuredPerson[]>>(`/api/v1/data/agreements/${contractId}/assured-people`).then((res) => res.data.data),

  getAssuredPerson: (id: string) =>
    backendApi.get<ApiResponse<AssuredPerson>>(`/api/v1/data/assured-people/${id}`).then((res) => res.data.data),

  createAssuredPerson: (data: Partial<AssuredPerson>) =>
    backendApi.post<ApiResponse<AssuredPerson>>('/api/v1/data/assured-people', data).then((res) => res.data.data),

  updateAssuredPerson: (id: string, data: Partial<AssuredPerson>) =>
    backendApi.put<ApiResponse<AssuredPerson>>(`/api/v1/data/assured-people/${id}`, data).then((res) => res.data.data),

  deleteAssuredPerson: (id: string) =>
    backendApi.delete<ApiResponse<void>>(`/api/v1/data/assured-people/${id}`).then((res) => res.data.data),

  verifyAssuredPeople: (contractIds: string[]) =>
    backendApi.post<ApiResponse<AssuredPerson[]>>('/api/v1/data/assured-people/verify', { contractIds }).then((res) => res.data.data),
}
